import React, { HTMLAttributes } from 'react'
import styled, { css } from 'styled-components'
import { STypographyParagraph } from '@components/Typography'
import { above } from '@styles/mixins/breakpoints'

export interface IValue {
  title: string
  value: string
}

export interface IRadio extends Omit<HTMLAttributes<HTMLDivElement>, 'onChange'> {
  name: string
  value: string
  onChange: (value: string) => void
  values: IValue[]
}

interface ISLabel {
  checked: boolean
  color?: string
}

const SLabel = styled.label<ISLabel>`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.colors.middleGray};
  transition: 0.2s;
  cursor: pointer;

  ${({ checked, color }) =>
    checked &&
    css`
      background-color: ${({ theme }) => color || theme.colors.green};
      border-color: ${({ theme }) => color || theme.colors.green};
      color: white;
      font-weight: 600;
    `}

  &:last-child {
    border-radius: 0 4px 4px 0;
  }

  &:first-child {
    border-radius: 4px 0 0 4px;
  }

  ${above('md')(css`
    width: 62px;
  `)}
`

const SWrap = styled.div`
  display: flex;
  height: 100%;
`

const SInput = styled.input`
  display: none;
`

const Radio: React.FC<IRadio> = ({ name, values, onChange, value: currentValue, color, ...divProps }) => {
  return (
    <SWrap {...divProps}>
      {values.map(({ title, value }) => {
        const checked = value === currentValue
        return (
          <SLabel key={value} checked={checked} color={color}>
            <STypographyParagraph textAlign="center" fontSize="16px" lineHeight="24px">
              {title}
            </STypographyParagraph>
            <SInput type="radio" name={name} value={value} checked={checked} onChange={() => onChange(value)} />
          </SLabel>
        )
      })}
    </SWrap>
  )
}

export default Radio
